import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation SceneDisable($uid: String!){
        scene_disable (uid: $uid) {
            success
        }
    }
`;

export async function sceneDisable(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ scene_disable: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.scene_disable;
}
